export default "__VITE_ASSET__Bm7J2ad8__"